// Read-only presentation: $ is a visual fallback, not historical currency attribution.
const code = value => {
  const normalized = typeof value === 'string' ? value.trim().toUpperCase() : '';
  return /^[A-Z]{3}$/.test(normalized) ? normalized : '';
};
export const invoiceCurrency = invoice => {
  if (invoice && Object.prototype.hasOwnProperty.call(invoice, 'currency')) return code(invoice.currency);
  return code(invoice?.total?.currency);
};
export const paymentCurrency = (payment, fallback = '') => {
  if (payment?.amount && typeof payment.amount === 'object' && Object.prototype.hasOwnProperty.call(payment.amount, 'currency')) return code(payment.amount.currency);
  if (payment && Object.prototype.hasOwnProperty.call(payment, 'currency')) return code(payment.currency);
  return code(fallback);
};
export const formatInvoiceCurrencyAmount = (value, currency) => {
  if (value && typeof value === 'object' && value.amount_minor == null) return '—';
  const amount = value && typeof value === 'object' ? Number(value.amount_minor) / 100 : Number(value);
  if (value === null || value === undefined || !Number.isFinite(amount)) return '—';
  const resolved = code(currency);
  return resolved
    ? new Intl.NumberFormat('en-AU', {style:'currency', currency:resolved}).format(amount)
    : `${amount < 0 ? '-' : ''}$${Math.abs(amount).toLocaleString('en-AU', {minimumFractionDigits:2, maximumFractionDigits:2})}`;
};
